import React from 'react';
import { Typography } from '@fupa/fupa-uikit';
import styled from 'styled-components';
const Container = styled.div.withConfig({
  componentId: "sc-1mvu0fc-0"
})(["display:flex;justify-content:center;align-items:center;height:100%;width:100%;"]);
export default function NoRowsOverlay(_ref) {
  let {
    error
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, {
    "data-sentry-element": "Container",
    "data-sentry-component": "NoRowsOverlay",
    "data-sentry-source-file": "NoRowsOverlay.tsx"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    "data-sentry-element": "Typography",
    "data-sentry-source-file": "NoRowsOverlay.tsx"
  }, error ? 'Beim Laden der Daten ist ein Fehler aufgetreten.' : 'Es sind noch keine Statistiken vorhanden.'));
}